<template>
  <main class="amp-page">
    <amp-main v-if="showAmpPage" :participant-id="participantId" />
    <amp-form v-else @event:check-access="checkAccess" :error="error" />
  </main>
</template>

<script>
import Vue from "vue"
import AMP from "./components/amp.vue"
import AMPForm from "./components/amp-form.vue"
import { AUTH_STORAGE_KEY } from "@pages/axoft-maximum-pro/consts/amp"

export default {
  name: "amp-page",
  components: {
    "amp-main": AMP,
    "amp-form": AMPForm,
  },
  data() {
    return {
      showAmpPage: false,
      participantId: null,
      error: null,
    }
  },
  created() {
    this.checkAuthFromStorage()
  },
  methods: {
    async checkAccess(email) {
      const defaultError =
        "Данный e-mail не найден среди списков участников мероприятия. Пожалуйста, введите другой e-mail или пройдите регистрацию по ссылке ниже."

      try {
        this.error = null

        if (!email) throw "Введите почту"

        const response = await Vue.http.get(`/api/events/getEvents/${email}`)

        if (response?.body?.participantID) {
          this.participantId = response.body.participantID
          localStorage.setItem(AUTH_STORAGE_KEY, "true")
          this.showAmpPage = true
        } else {
          if (response?.status === 200) {
            if (response?.body?.error) throw response.body.error
            else throw defaultError
          }

          throw "Что-то пошло не так"
        }
      } catch (err) {
        if (typeof err === "string") this.error = err
        else this.error = "Что-то пошло не так"
        console.error(err)
      }
    },
    checkAuthFromStorage() {
      const auth = localStorage.getItem(AUTH_STORAGE_KEY)

      if (auth) {
        this.showAmpPage = true
      }
    },
  },
}
</script>

<style lang="sass">
@import "~@src/sass/params"

.amp-page
  display: flex
  background: $dark-blue
  padding-block: 130px 121px

  @media (max-width: $tablet-header)
    padding-block-start: 80px

  @media (max-width: $mobile-size)
    padding-top: 0
</style>



// WEBPACK FOOTER //
// src/templates/pages/axoft-maximum-pro/index.vue